<template>
    <div class="mainContainer pbottom50">
        <Banner />
        <!-- 搜索模块儿 -->
        <div class="uni-search-container">
            <div class="w11">
                <!-- 所有课程搜索 -->
                <div class="searchTags">
                    <search-template-filters>
                        <span class="tagsLabel" slot="tagsLabel"
                            >所有课程：</span
                        >
                        <div class="tagsList" slot="tagsList">
                            <search-template class="active"
                                >书法课堂</search-template
                            >
                            <search-template>绘画学院</search-template>
                            <search-template>音乐学院</search-template>
                            <search-template>舞蹈学院</search-template>
                            <search-template>健康学院</search-template>
                            <search-template>烹饪学院</search-template>
                            <search-template>摄影学院</search-template>
                        </div>
                    </search-template-filters>
                </div>
                <!-- 按讲师搜索 -->
                <div class="searchTags">
                    <search-template-filters>
                        <span class="tagsLabel" slot="tagsLabel">按讲师：</span>
                        <div class="tagsList" slot="tagsList">
                            <search-template class="active"
                                >全部</search-template
                            >
                            <search-template>王二小</search-template>
                            <search-template>王建国</search-template>
                            <search-template>胡八一</search-template>
                            <search-template>李建军</search-template>
                        </div>
                    </search-template-filters>
                </div>
            </div>
        </div>
        <!-- 列表、分页器 -->
        <div class="bgGray videoCoverListContainer">
            <!-- 列表 -->
            <div class="w1120 videoCoverList">
                <video-cover-item
                    v-for="i in 12"
                    :key="i"
                    path="/pcViews/learn/class-room-details"
                ></video-cover-item>
            </div>
            <!-- 分页器 -->
            <div class="block page_box mtb30" v-if="page.total != 0">
                <el-pagination
                    layout="prev, pager, next"
                    :page-size="page.size"
                    :background="true"
                    :total="page.total"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
            </div>
            <div v-if="page.total === 0" class="noMessage">暂无数据</div>
        </div>
    </div>
</template>

<script>
import Banner from "views/PcViews/Learn/Classroom/List/Banner";
import SearchTemplateFilters from "components/contents/searchTemplateFilters/SearchTemplateFilters";
import SearchTemplate from "components/common/searchTemplate/SearchTemplate";
import VideoCoverItem from "components/common/videoCoverItem/VideoCoverItem";
export default {
    components: {
        Banner,
        SearchTemplateFilters,
        SearchTemplate,
        VideoCoverItem,
    },
    data() {
        return {
            page: {
                current: 1,
                size: 12,
                total: 100,
            },
        };
    },
    methods: {
        //分页数切换
        handleCurrentChange(val) {
            this.page.current = val;
        },
    },
};
</script>


<style lang="less" scoped>
.noMessage {
    height: 120px;
    line-height: 120px;
    font-size: 16px;
    color: #818181;
    text-align: center;
}
.videoCoverList {
    display: flex;
    flex-wrap: wrap;
}

.w1120 {
    width: 1120px;
    margin: 0 auto;
}

.videoCoverListContainer {
    padding: 10px 0;
}
.uni-search-container {
    padding: 35px 0 10px;
    background: #fff;
}
</style>
